import React from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Hammer,
  Gift,
  ClipboardList,
  Image,
  Bot,
  Wallet
} from "lucide-react";

const mapStateToProps = (state) => {
  return {
    isLogin: state.isLogin,
    address: state.address
  }
}

const Foot = () => {

  const { t } = useTranslation();

  const location = useLocation();
  const navigate = useNavigate();

  const { pathname } = location;

  const tabs = [
    {
      key: "mint",
      label: t('foot.铸造'),
      icon: Hammer,
      path: "/"
    },
    {
      key: "airdrop",
      label: t('foot.招募'),
      icon: Gift,
      path: "/airdrop"
    },
    {
      key: "task",
      label: t('foot.任务'),
      icon: ClipboardList,
      path: "/task"
    },
    {
      key: "nft",
      label: t('foot.NFT'),
      icon: Image,
      path: "/nft"
    },
    {
      key: "ai",
      label: t('foot.生态'),
      icon: Bot,
      path: "/ecosystem"
    },
    {
      key: "asset",
      label: t('foot.资产'),
      icon: Wallet,
      path: "/asset"
    }
  ];

  return (
    <div className="lg:w-1/3 md:w-1/3 sm:1/2 fixed bottom-0 left-0 z-50 w-full px-2">

      <div
        className="
          mx-auto
          flex
          h-[55px]
          max-w-[430px]
          footBg
          items-center
          justify-between
          bg-[#05090d]/95
          px-2
          backdrop-blur-md
          shadow-[0_0_18px_rgba(255,132,0,.25)]
          [clip-path:polygon(16px_0,calc(100%-16px)_0,100%_16px,100%_calc(100%-16px),calc(100%-16px)_100%,16px_100%,0_calc(100%-16px),0_16px)]
        "
      >

        {tabs.map((tab) => {

          const Icon = tab.icon;

          const isActive =
            pathname === tab.path ||
            pathname.startsWith(tab.path + "/");

          return (

            <button
              key={tab.key}
              onClick={() => navigate(tab.path)}
              className={`
                relative
                flex
                h-[35px]
                flex-1
                flex-col
                items-center
                justify-center
                gap-[4px]
                text-[10px]
                transition-all
                duration-300
                ${isActive
                  ? "text-text1"
                  : "text-white/50 hover:text-white"}
              `}
            >

              {isActive && (
                <span
                  className="
                    active-tab-glow
                    absolute
                    inset-x-2
                    inset-y-0
                    rounded-md
                    border
                    border-orange-400/70
                    bg-orange-400/10
                    [clip-path:polygon(8px_0,calc(100%-8px)_0,100%_8px,100%_calc(100%-8px),calc(100%-8px)_100%,8px_100%,0_calc(100%-8px),0_8px)]
                  "
                />
              )}

              <Icon
                size={12}
                className={`
                  relative
                  z-10
                  transition-all
                  duration-300
                  ${isActive
                    ? "scale-125 drop-shadow-[0_0_8px_rgba(255,132,0,.95)]"
                    : ""}
                `}
              />

              <span className="relative z-10 leading-none">
                {tab.label}
              </span>

            </button>

          );

        })}

      </div>

    </div>
  );
};

export default connect(mapStateToProps)(Foot);